import db from './modules/db'
import releases from './modules/releases'


import theme from './modules/theme'
import log from './modules/log'

import fullscreen from './modules/fullscreen'
import ua from './modules/ua'
import gray from './modules/gray'
import page from './modules/page'
import transition from './modules/transition'
import search from './modules/search'
import size from './modules/size'
import discount from './modules/discount'
import subCampProduct from './modules/subCampProduct'
import adjustment from './modules/adjustment'
import fullamount from './modules/fullamount'
import Commission from './modules/Commission'
import user from './modules/user'
import purchasing from './modules/purchasing'
import poster from './modules/poster'
export default {
  namespaced: true,
  modules: {
    db,
    releases,
    user,
    purchasing,
    theme,
    log,
    fullscreen,
    ua,
    gray,
    page,
    transition,
    search,
    size,

    discount,

    subCampProduct,
    adjustment,
    fullamount,
    Commission,
    poster,

  }
}